import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ColorMaster = () => {

  const [ColorUser, setColorUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
        );

        // API uses "colors"
        const apiData = response?.data?.colors;

        setColorUser(Array.isArray(apiData) ? apiData : []);
      } catch (error) {
        console.error(error);
        setColorUser([]);
      }
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_mst_prod_color",
        { color_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        setColorUser((prevUser) =>
          prevUser.filter((user) => user.color_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Color-list");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Color.");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Color Master</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="#">Master</a></li>
                <li className="breadcrumb-item active">Color Master</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Color List */}
        <div className="row">
          <div className="col-md-12">

            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5>All Colors</h5>
                <div className='d-flex gap-2'>
                  <Link to="/color-add" className="btn btn-sm btn-blue">Add Color</Link>
                  <Link to="#" className="btn btn-sm btn-success">Export</Link>
                </div>
              </div>

              <div className="card-body p-0">
                <div className="table-responsive">

                  <table className="table table-bordered table-hover">
                    <thead className="bg-light">
                      <tr>
                        <th>Sr No</th>
                        <th>Color Name</th>
                        <th>Preview</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {ColorUser.map((color, index) => (
                        <tr key={color.color_id}>
                          <td>{index + 1}</td>
                          <td>{color.color_name}</td>

                          {/* FIXED Preview Box */}
                          <td>
                            <div style={{
                              width: '30px',
                              height: '30px',
                              backgroundColor: color.code,  
                              border: '1px solid #ccc',
                              borderRadius: '4px'
                            }} />
                          </td>

                          <td>
                            <span className={`badge ${
                              color.status === 'Active'
                                ? 'bg-success-subtle text-success'
                                : 'bg-danger-subtle text-danger'
                            }`}>
                              {color.status}
                            </span>
                          </td>

                          <td>
                            <div className="d-flex gap-2">
                              <Link to={`/color-edit/${color.color_id}`}
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </Link>

                              <span
                                onClick={() => deleteUser(color.color_id)}
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i className="fa-solid fa-trash fs-16"></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}

                      {ColorUser.length === 0 && (
                        <tr>
                          <td colSpan="5" className="text-center text-muted">
                            No colors available
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>

                </div>
              </div>

            </div>

          </div>
        </div>

        {/* Footer */}
              <footer className="footer">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12 text-center">
                      © Venton. Crafted by{" "}
                      <iconify-icon
                        icon="iconamoon:heart-duotone"
                        className="fs-18 align-middle text-danger"
                      />{" "}
                      <Link to="#" className="fw-bold footer-text" target="_blank">
                        Techzaa
                      </Link>
                    </div>
                  </div>
                </div>
              </footer>

      </div>
    </div>
  );
};

export default ColorMaster;
